export interface PercentageDraft { percentage: string; label: string; issued_date: string; generation_key: string }
function generationKey(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
export const newPercentageDraft = (): PercentageDraft => ({ percentage: '', label: '', issued_date: new Date().toLocaleDateString('en-CA'), generation_key: generationKey() });
export const validPercentage = (draft: PercentageDraft) => Number(draft.percentage) > 0 && Number(draft.percentage) <= 100 && !!draft.issued_date;
